import { type BaseVendorConnectionRepository } from "../../_Bases/BaseVendorConnectionRepository";
import { type LocalDatabaseVendorConnection } from "../../_Bases/BaseVendorConnectionRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBVendorConnectionRepository extends BaseIndexedDBRepository<
    LocalDatabaseVendorConnection
> implements BaseVendorConnectionRepository {
    public readonly source: InternalIndexedDBDatabase["vendorConnections"];
    protected readonly dataTypeName = "Vendor Connection";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.vendorConnections;
    }

    public search(needle: string): Promise<Array<LocalDatabaseVendorConnection>> {
        if(!needle) {
            return this.all();
        }

        return this.source
            .where("name")
            .startsWithIgnoreCase(needle)
            .toArray();
    }
}
